<template>
  <Content nav="true" admin="true">
    <h1>Edit Event</h1>
    <form class="pure-form pure-form-aligned">
      <fieldset>
        <div class="pure-control-group">
          <label for="name">Name</label>
          <input v-model="event.name" id="name" type="text" placeholder="Name">
        </div>
        <div class="pure-control-group">
          <label for="date">Date</label>
          <datetime type="datetime" v-model="event.date"></datetime>
        </div>
        <div class="pure-control-group">
          <label for="location">Location</label>
          <input v-model="event.location" id="location" type="text" placeholder="Location">
        </div>
        <div class="pure-control-group">
          <label for="description">Description</label>
          <textarea v-model="event.description" id="description" placeholder="Description"></textarea>
        </div>
      </fieldset>
      <fieldset>
        <div class="pure-controls">
          <button @click.prevent="save" :disabled="saving" class="pure-button pure-button-primary">
            <font-awesome-icon icon="save"/>&nbsp; Save
          </button>
        </div>
      </fieldset>
    </form>
  </Content>
</template>

<script>
import Session from '@/mixins/Session.js'
import { Datetime } from 'vue-datetime'

export default {
  name: 'Event',
  mixins: [Session],
  beforeMount() {
    this.authorize()
  },
  props: ['id'],
  components: { datetime: Datetime },
  data() {
    return {
      saving: false,
      event: {}
    }
  },
  computed: {
    ref() {
      return this.$database.collection('events').doc(this.id)
    }
  },
  methods: {
    get() {
      this.ref.get().then(doc => (this.event = doc.data()))
    },
    format() {
      this.event.description = this.event.description.trim()
      this.event.location = this.event.location.trim()
      this.event.name = this.event.name.trim()
    },
    save() {
      this.format()
      this.saving = true
      this.ref.set(this.event).then(() => (this.saving = false))
    }
  },
  mounted() {
    this.get()
  }
}
</script>

<style lang="less" scoped>
.vdatetime {
  display: inline-block;
}

textarea {
  height: 6em;
  width: 50%;
}
</style>
